import { Mapper } from '@/core/mapper/base-mapper';
import { GetDataExtractionModelListResponseDTO } from '@/core/dto/data-extraction';
import { REPORT_ACRONYM_KEYS } from '@/utils/constants';
import type { DataExtractionModelListItems } from '@/types';

export class GetDataExtractionModelListMapper implements Mapper<DataExtractionModelListItems> {
	constructor(private readonly data: GetDataExtractionModelListResponseDTO) {}

	toDomain(): DataExtractionModelListItems {
		return {
			...this.data,
			rows: this.data.rows.map((item) => ({
				...item,
				report_name: item.report_name
					? REPORT_ACRONYM_KEYS[item.report_name] || item.report_name
					: item.report_name
			}))
		};
	}
}
